const embroideryFaq = [
  {
    question: "What is embroidery?",
    answer:
      "Embroidery is a decorative process where a design or pattern is stitched onto fabric using thread. It adds a textured and durable embellishment to various items such as apparel, hats, bags, and more.",
  },
  {
    question: "What types of items can be embroidered?",
    answer:
      "Embroidery is versatile and can be applied to a wide range of items, including garments like polo shirts, jackets, hats, as well as accessories like bags and patches. It's an excellent way to personalize and brand various textiles.",
  },
  {
    question: "How is embroidery different from other customization methods?",
    answer:
      "Unlike printing methods, which apply ink to the surface, embroidery involves stitching thread into the fabric, creating a raised and textured design. This adds a premium and long-lasting touch to the customized item, making it ideal for both casual and professional apparel.",
  },
  {
    question: "What is the typical turnaround time for embroidery orders?",
    answer:
      "Turnaround times for embroidery orders depend on factors like the complexity of the design, order quantity, and current workload. We work closely with our clients to establish realistic timelines and strive to deliver high-quality embroidered products within agreed-upon deadlines. Contact us for specific timelines related to your project.",
  },
  {
    question: "Can any design be embroidered?",
    answer:
      "Most designs can be embroidered, but intricate details or very small text may not translate well. It's best to choose designs with clear lines and defined shapes for optimal embroidery results. Our team can assist you in adjusting or refining your design for the best embroidery outcome.",
  },
];
export default embroideryFaq;
